import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../../Utils/saga"
import Creators, { RequestsWithdrawalTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsWithdrawalActions: {
    request: Creators.getRequestsWithdrawalRequest,
    success: Creators.getRequestsWithdrawalSuccess,
    errors: Creators.requestsWithdrawalFailure
  },
  deleteWithdrawalActions: {
    request: Creators.deleteWithdrawalRequest,
    success: Creators.deleteWithdrawalSuccess,
    errors: Creators.requestsWithdrawalFailure
  },
  getPayoutMethodActions: {
    request: Creators.getPayoutMethodRequest,
    success: Creators.getPayoutMethodSuccess,
    errors: Creators.getPayoutMethodFailure
  },
  setStatusActions: {
    request: Creators.setStatusRequest,
    success: Creators.setStatusSuccess,
    errors: Creators.setStatusFailure
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_WITHDRAWAL_REQUEST]: {
    api: services.getRequestsWithdrawal,
    actions: actions.getRequestsWithdrawalActions
  },
  [constants.DELETE_WITHDRAWAL_REQUEST]: {
    api: services.deleteWithdrawal,
    actions: actions.deleteWithdrawalActions
  },
  [constants.GET_PAYOUT_METHOD_REQUEST]: {
    api: services.getPayoutMethod,
    actions: actions.getPayoutMethodActions
  },
  [constants.SET_STATUS_REQUEST]: {
    api: services.setStatus,
    actions: actions.setStatusActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_WITHDRAWAL_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_WITHDRAWAL_REQUEST])
  )
  yield takeLatest(constants.DELETE_WITHDRAWAL_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_WITHDRAWAL_REQUEST])
  )
  yield takeLatest(constants.GET_PAYOUT_METHOD_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PAYOUT_METHOD_REQUEST])
  )
  yield takeLatest(constants.SET_STATUS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.SET_STATUS_REQUEST])
  )
}
